module.exports = __webpack_public_path__ + "static/media/logo.9f7d2e14.png";